import { render, staticRenderFns } from "./user_profile_page.vue?vue&type=template&id=6d20554a&scoped=true&"
import script from "./user_profile_page.vue?vue&type=script&lang=js&"
export * from "./user_profile_page.vue?vue&type=script&lang=js&"
import style0 from "./user_profile_page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./user_profile_page.vue?vue&type=style&index=1&id=6d20554a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20554a",
  null
  
)

export default component.exports